import {
  TSUNAMI_EVENT_SEARCH_CLEAR,
  TSUNAMI_EVENT_SEARCH_REQUEST,
  TSUNAMI_EVENT_SEARCH_CLEAR_REDIRECT,
  TSUNAMI_EVENT_SEARCH_AREA_REQUEST,
  TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST,
  TSUNAMI_EVENT_SEARCH_REGION_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST,
  TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST,
  TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST,
} from './tsunamiEventSearchReducer';
import {
  TSUNAMI_EVENT_SEARCH_TOGGLE_SECTION,
} from './tsunamiEventSearchPageReducer';

export const searchTsunamiEvents = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: TSUNAMI_EVENT_SEARCH_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearTsunamiEventSearch = () => ({ type: TSUNAMI_EVENT_SEARCH_CLEAR });
export const toggleSection = ({ section }) => ({ type: TSUNAMI_EVENT_SEARCH_TOGGLE_SECTION, section });
export const clearRedirect = () => ({ type: TSUNAMI_EVENT_SEARCH_CLEAR_REDIRECT });

export const getRegions = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST, history });
export const getAreas = ({ country, history }) => ({ type: TSUNAMI_EVENT_SEARCH_AREA_REQUEST, country, history });

export const getRunupRegions = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST, history });
export const getRunupCountries = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST, history });
export const getRunupAreas = ({ country, history }) => ({ type: TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST, country, history });
export const getRunupMeasurementTypes = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST, history });
export const getValidity = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST, history });
export const getCauses = ({ history }) => ({ type: TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST, history });
